import React, { useState } from 'react';
import {
  BankOutlined,
  GoldOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
  MailOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons';
import ApprovalWorkflowIndex from './ApprovalWorkflow';
import BranchListIndex from './BranchList';
import LedgerEmailsIndex from './LedgerEmails';
import MetalsIndex from './Metals';
import OrganizationSettingsIndex from './OrganizationSettings';
import ResetPasswordIndex from './ResetPassword';
import './index.scss';

type SettingsTab =
  | 'branches'
  | 'approvals'
  | 'ledger-emails'
  | 'metals'
  | 'organization'
  | 'reset-password';

export default function SettingsIndex(): JSX.Element {
  // Settings is only reachable by the superadmin (sidebar item, route guard and the API all enforce it)
  const tabs: Array<{
    key: SettingsTab;
    label: string;
    icon: JSX.Element;
  }> = [
    { key: 'branches', label: 'Branches', icon: <UnorderedListOutlined /> },
    {
      key: 'approvals',
      label: 'Approvals',
      icon: <SafetyCertificateOutlined />,
    },
    { key: 'ledger-emails', label: 'Ledger Emails', icon: <MailOutlined /> },
    { key: 'metals', label: 'Metals', icon: <GoldOutlined /> },
    { key: 'organization', label: 'Organization', icon: <BankOutlined /> },
    { key: 'reset-password', label: 'Reset Password', icon: <LockOutlined /> },
  ];

  const [active, setActive] = useState<SettingsTab>(tabs[0].key);

  return (
    <div className="settings__page">
      <p className="settings__heading">Settings</p>
      <div className="settings__layout">
        <nav className="settings__nav">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`settings__nav-item${
                active === tab.key ? ' settings__nav-item--active' : ''
              }`}
              onClick={() => {
                setActive(tab.key);
              }}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </button>
          ))}
        </nav>

        <div className="settings__content">
          {active === 'branches' && <BranchListIndex />}
          {active === 'approvals' && <ApprovalWorkflowIndex />}
          {active === 'ledger-emails' && <LedgerEmailsIndex />}
          {active === 'metals' && <MetalsIndex />}
          {active === 'organization' && <OrganizationSettingsIndex />}
          {active === 'reset-password' && <ResetPasswordIndex />}
        </div>
      </div>
    </div>
  );
}
